<div
  *ngIf="message as m"
  class="fixed inset-0 z-20 flex items-center justify-center bg-main-background bg-opacity-75 backdrop-blur-sm"
  (click)="closed.emit()">
  <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
    <div
      class="w-full max-w-screen-sm flex flex-col my-6 p-8 bg-white rounded-md shadow-lg overflow-hidden"
      (click)="$event.stopPropagation()">

      <div class="flex items-start justify-between gap-4 pb-4 border-b border-gray-200">
        <div>
          <h2 class="oswald-font text-2xl text-nside-orange-400 break-words">{{ m.subject || '(No subject)' }}</h2>
          <span class="mt-1.5 inline-block rounded-full px-2.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-600">
            {{ messageTypeLabel(m.type) }}
          </span>
        </div>
        <button type="button" (click)="closed.emit()" class="shrink-0 text-gray-400 hover:text-gray-600">
          <lucide-icon [img]="icons.X" [size]="20"></lucide-icon>
        </button>
      </div>

      <div class="mt-4 space-y-1.5 text-sm">
        <div class="flex gap-2">
          <span class="w-14 shrink-0 text-gray-400">From</span>
          <span class="text-gray-800">
            {{ m.senderName }}<span *ngIf="m.senderEmail" class="text-gray-500"> ({{ m.senderEmail }})</span>
          </span>
        </div>
        <div class="flex gap-2">
          <span class="w-14 shrink-0 pt-0.5 text-gray-400">To</span>
          <div class="flex-1 min-w-0 max-h-24 overflow-y-auto">
            <div *ngIf="!m.sentTo.length" class="text-gray-800">—</div>
            <div *ngFor="let recipient of m.sentTo" class="text-gray-800 truncate">{{ recipient }}</div>
          </div>
        </div>
        <div class="flex gap-2">
          <span class="w-14 shrink-0 text-gray-400">Sent</span>
          <span class="text-gray-800">{{ (m.created ? m.created + 'Z' : '') | date: 'MM/dd/yyyy - HH:mm' }}</span>
        </div>
      </div>

      <div class="email-body mt-4 max-h-[50vh] overflow-y-auto rounded-lg border border-gray-200 bg-white p-5 text-sm" [innerHTML]="m.body || noContentHtml"></div>

      <div class="mt-6 flex justify-end">
        <button
          type="button"
          (click)="closed.emit()"
          class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">
          Close
        </button>
      </div>

    </div>
  </div>
</div>
